import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';
import { ReactNode } from 'react';

import { FlowCoreProvider } from './FlowCoreContext';
import { PortProvider } from './PortContext';

interface FlowModeProviderProps {
  children: ReactNode;
}

export const FlowModeProvider = ({ children }: FlowModeProviderProps) => {
  // TODO: remove this when diagrams are ready
  // The re-rendering in FlowCoreProvider needs to be re-considred as it is causing performance issues
  const { venngageE2 } = useVenngageE1Gate();
  if (!venngageE2?.experiments?.enableFlowMode) return <>{children}</>;

  return (
    <FlowCoreProvider>
      <PortProvider>{children}</PortProvider>
    </FlowCoreProvider>
  );
};
